import { Placeholder } from "@telegram-apps/telegram-ui";
import { Button, Image } from "antd-mobile";
import { useTranslation } from "react-i18next";
import { IconLoading, IconWalletLogo } from "~/components/Iconfont/Iconfont";
import { useUXUYWallet } from "~/Provider/UXUYWallet";
import WalletImg from "~/assets/imgs/UXUY-Wallet-logo.gif";
import { Page } from "~/components/Page/Page";

const WalletNotConnect = () => {
    const { t } = useTranslation();
    const { isConnecting, connect } = useUXUYWallet();
    return (
        <Page>
            <Placeholder
                className="py-28"
                header={
                    <span className="text-text_1 text-h4">
                        {t("wallet_not_connected_yet")}
                    </span>
                }
                description={
                    <p className="text-text_2 text-body1">
                        {t("wallet_not_connected_yet_desc")}
                    </p>
                }
                action={
                    <Button
                        color="primary"
                        fill="solid"
                        block
                        style={
                            {
                                width: "80%",
                                height: 54,
                                "--border-radius": "12px",
                                "--border-color": "transparent",
                                "--text-color": "var(--White)",
                                "--background-color": `var(--color_text_brand)`,
                            } as React.CSSProperties
                        }
                        onClick={connect}
                    >
                        <span className="flex items-center justify-center text-h6 font-semibold">
                            {isConnecting && (
                                <IconLoading className="text-h5 mr-1" />
                            )}
                            {t("connect_uxuy_wallet")}
                        </span>
                    </Button>
                }
            >
                <Image
                    src={WalletImg}
                    width={80}
                    height={80}
                    lazy
                    style={{ borderRadius: "50%" }}
                    fallback={
                        <div className="bg-text_brand rounded-full">
                            <IconWalletLogo className="text-text_brand text-[80px]" />
                        </div>
                    }
                    placeholder={
                        <div className="bg-text_brand rounded-full">
                            <IconWalletLogo className="text-text_brand text-[80px]" />
                        </div>
                    }
                />
            </Placeholder>
        </Page>
    );
};

export default WalletNotConnect;
